import * as Types from '../../../../generated/graphql.types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateSpotMutationVariables = Types.Exact<{
  input: Types.UpdateSpotInput;
}>;


export type UpdateSpotMutation = { __typename?: 'MutationRoot', updateSpot: { __typename?: 'Spot', id: string } };

export type InsertAfterSpotInputMutationVariables = Types.Exact<{
  input: Types.InsertAfterSpotInput;
}>;


export type InsertAfterSpotInputMutation = { __typename?: 'MutationRoot', insertAfterSpot: { __typename?: 'InsertSpotFailure', message: string } | { __typename?: 'InsertSpotSuccess', spot: { __typename?: 'Spot', id: string } } };

export type InsertStartMutationVariables = Types.Exact<{
  input: Types.InsertStartInput;
}>;


export type InsertStartMutation = { __typename?: 'MutationRoot', insertStart: { __typename?: 'Spot', id: string } };

export type InsertDestMutationVariables = Types.Exact<{
  input: Types.InsertDestInput;
}>;


export type InsertDestMutation = { __typename?: 'MutationRoot', insertDest: { __typename?: 'Spot', id: string } };

export type RemoveMultipleSpotsMutationVariables = Types.Exact<{
  input: Types.RemoveMultipleSpotsInput;
}>;


export type RemoveMultipleSpotsMutation = { __typename?: 'MutationRoot', removeMultipleSpots: Array<{ __typename?: 'Spot', id: string }> };

export type RemoveSpotMutationVariables = Types.Exact<{
  input: Types.RemoveSpotInput;
}>;


export type RemoveSpotMutation = { __typename?: 'MutationRoot', removeSpot: { __typename?: 'Spot', id: string } };

export type UpdateThumbnailMutationVariables = Types.Exact<{
  input: Types.UpdateThumbnailInput;
}>;


export type UpdateThumbnailMutation = { __typename?: 'MutationRoot', updateThumbnail: string };


export const UpdateSpotDocument = gql`
    mutation UpdateSpot($input: UpdateSpotInput!) {
  updateSpot(input: $input) {
    id
  }
}
    `;

export function useUpdateSpotMutation() {
  return Urql.useMutation<UpdateSpotMutation, UpdateSpotMutationVariables>(UpdateSpotDocument);
};
export const InsertAfterSpotInputDocument = gql`
    mutation InsertAfterSpotInput($input: InsertAfterSpotInput!) {
  insertAfterSpot(input: $input) {
    ... on InsertSpotSuccess {
      spot {
        id
      }
    }
    ... on InsertSpotFailure {
      message
    }
  }
}
    `;

export function useInsertAfterSpotInputMutation() {
  return Urql.useMutation<InsertAfterSpotInputMutation, InsertAfterSpotInputMutationVariables>(InsertAfterSpotInputDocument);
};
export const InsertStartDocument = gql`
    mutation InsertStart($input: InsertStartInput!) {
  insertStart(input: $input) {
    id
  }
}
    `;

export function useInsertStartMutation() {
  return Urql.useMutation<InsertStartMutation, InsertStartMutationVariables>(InsertStartDocument);
};
export const InsertDestDocument = gql`
    mutation InsertDest($input: InsertDestInput!) {
  insertDest(input: $input) {
    id
  }
}
    `;

export function useInsertDestMutation() {
  return Urql.useMutation<InsertDestMutation, InsertDestMutationVariables>(InsertDestDocument);
};
export const RemoveMultipleSpotsDocument = gql`
    mutation RemoveMultipleSpots($input: RemoveMultipleSpotsInput!) {
  removeMultipleSpots(input: $input) {
    id
  }
}
    `;

export function useRemoveMultipleSpotsMutation() {
  return Urql.useMutation<RemoveMultipleSpotsMutation, RemoveMultipleSpotsMutationVariables>(RemoveMultipleSpotsDocument);
};
export const RemoveSpotDocument = gql`
    mutation RemoveSpot($input: RemoveSpotInput!) {
  removeSpot(input: $input) {
    id
  }
}
    `;

export function useRemoveSpotMutation() {
  return Urql.useMutation<RemoveSpotMutation, RemoveSpotMutationVariables>(RemoveSpotDocument);
};
export const UpdateThumbnailDocument = gql`
    mutation updateThumbnail($input: UpdateThumbnailInput!) {
  updateThumbnail(input: $input)
}
    `;

export function useUpdateThumbnailMutation() {
  return Urql.useMutation<UpdateThumbnailMutation, UpdateThumbnailMutationVariables>(UpdateThumbnailDocument);
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateSpotMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updateSpot })
 *   )
 * })
 */
export const mockUpdateSpotMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateSpotMutationVariables>, GraphQLContext<UpdateSpotMutation>, any>) =>
  graphql.mutation<UpdateSpotMutation, UpdateSpotMutationVariables>(
    'UpdateSpot',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsertAfterSpotInputMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ insertAfterSpot })
 *   )
 * })
 */
export const mockInsertAfterSpotInputMutation = (resolver: ResponseResolver<GraphQLRequest<InsertAfterSpotInputMutationVariables>, GraphQLContext<InsertAfterSpotInputMutation>, any>) =>
  graphql.mutation<InsertAfterSpotInputMutation, InsertAfterSpotInputMutationVariables>(
    'InsertAfterSpotInput',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsertStartMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ insertStart })
 *   )
 * })
 */
export const mockInsertStartMutation = (resolver: ResponseResolver<GraphQLRequest<InsertStartMutationVariables>, GraphQLContext<InsertStartMutation>, any>) =>
  graphql.mutation<InsertStartMutation, InsertStartMutationVariables>(
    'InsertStart',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsertDestMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ insertDest })
 *   )
 * })
 */
export const mockInsertDestMutation = (resolver: ResponseResolver<GraphQLRequest<InsertDestMutationVariables>, GraphQLContext<InsertDestMutation>, any>) =>
  graphql.mutation<InsertDestMutation, InsertDestMutationVariables>(
    'InsertDest',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRemoveMultipleSpotsMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ removeMultipleSpots })
 *   )
 * })
 */
export const mockRemoveMultipleSpotsMutation = (resolver: ResponseResolver<GraphQLRequest<RemoveMultipleSpotsMutationVariables>, GraphQLContext<RemoveMultipleSpotsMutation>, any>) =>
  graphql.mutation<RemoveMultipleSpotsMutation, RemoveMultipleSpotsMutationVariables>(
    'RemoveMultipleSpots',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRemoveSpotMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ removeSpot })
 *   )
 * })
 */
export const mockRemoveSpotMutation = (resolver: ResponseResolver<GraphQLRequest<RemoveSpotMutationVariables>, GraphQLContext<RemoveSpotMutation>, any>) =>
  graphql.mutation<RemoveSpotMutation, RemoveSpotMutationVariables>(
    'RemoveSpot',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateThumbnailMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updateThumbnail })
 *   )
 * })
 */
export const mockUpdateThumbnailMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateThumbnailMutationVariables>, GraphQLContext<UpdateThumbnailMutation>, any>) =>
  graphql.mutation<UpdateThumbnailMutation, UpdateThumbnailMutationVariables>(
    'updateThumbnail',
    resolver
  )
